import styled from 'styled-components';

export const AccordionContainer = styled.div`
  margin-top: ${props => props.theme.space['3.0']};

  ${props => props.theme.mediaQueries.mediumDown} {
    margin-top: ${props => props.theme.space['1.4']};
  }
`;
